import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SurveyDataService {
  private readonly $agreementIdValue = signal<number | undefined>(undefined);

  public $agreementId = this.$agreementIdValue.asReadonly();

  public setAgreementId(agreementId: number) {
    this.$agreementIdValue.set(agreementId);
  }
}
